import { Component, computed, input, output, signal, viewChild, ChangeDetectionStrategy } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { FullScreenModalConfig, MobileMaxWidth, MONTHS_LIST } from '@lla-platform/core/core-util'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { MonthSelectorDialogComponent } from '../month-selector-dialog/month-selector-dialog.component'
import { MonthSelectorComponent } from '../month-selector/month-selector.component'

@UntilDestroy()
@Component({
  selector: 'lla-month-selector-filter',
  templateUrl: './month-selector-filter.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class MonthSelectorFilterComponent {
  monthSelector = viewChild<MonthSelectorComponent>('monthSelector')

  selectedMonth = input(new Date().getFullYear() * 100 + (new Date().getMonth() + 1)) // YYYYMM
  includeFuture = input(false)
  extraClasses = input('')

  selectedMonthChanged = output<number>()

  window = window
  mobileMaxWidth = MobileMaxWidth

  menuIsOpen = signal(false)

  private months = MONTHS_LIST

  selectedYear = computed(() => Math.floor(this.selectedMonth() / 100))
  selectedMonthIndex = computed(() => (this.selectedMonth() % 100) - 1)

  selectedMonthLabel = computed(() => {
    const monthIndex = this.selectedMonthIndex()
    const year = this.selectedYear()
    if (monthIndex >= 0 && monthIndex < 12) {
      return `${this.months[monthIndex]} ${year}`
    }
    return ''
  })

  constructor(private dialogService: MatDialog) {}

  onMonthSelected(value: number) {
    this.selectedMonthChanged.emit(value)
  }

  onMenuClosed() {
    this.menuIsOpen.set(false)
    const selector = this.monthSelector()
    if (selector) {
      selector.resetViewYear()
    }
  }

  openMonthSelectorModal() {
    this.dialogService
      .open(MonthSelectorDialogComponent, {
        ...FullScreenModalConfig,
        data: {
          selectedMonth: this.selectedMonth(),
          includeFuture: this.includeFuture()
        }
      })
      .afterClosed()
      .pipe(untilDestroyed(this))
      .subscribe((res: number) => {
        if (!res) return
        this.selectedMonthChanged.emit(res)
      })
  }
}
